
import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router-dom';

class MapContainer extends Component {
  constructor(props) {
    super(props);
    const api = (process.env.REACT_APP_API_BASE_URL || '') + '/api/v1.0/locations';
    this.state = {
      locations: [],
      api: api,
      showingInfoWindow: false,
      picturesPage: '/pictures/?',
      selectedLocation: null,
      isMapLoaded: false
    };
    this.mapRef = React.createRef();
  }

  componentDidMount() {
    console.log('entered DidMount')
    fetch(this.state.api)
      .then(results => results.json())
      .then(data => {
        this.setState({ locations: data.locations }, () => {
          this.loadMap();
        });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.google !== this.props.google || prevState.locations !== this.state.locations) {
      this.loadMap();
    }
  }

  loadMap() {

    if (this.props && this.props.google) {
      const { google } = this.props;
      const maps = google.maps;
      const node = this.mapRef.current;
      const picturesPage = this.state.picturesPage;


      const mapConfig = Object.assign({}, {
        center: { lat: 20, lng: 0 },
        zoom: 3,
        mapTypeId: 'hybrid', // Darker base map
        disableDefaultUI: false, // allow UI controls so we can zoom
        mapTypeControl: false, // hide map type
        streetViewControl: false, // hide street view
        fullscreenControl: false, // hide fullscreen
        zoomControl: true, // explicit zoom control
        zoomControlOptions: {
            position: maps.ControlPosition.LEFT_CENTER
        },
        gestureHandling: 'greedy' // allow single finger pan/zoom on mobile
      });
      this.map = new maps.Map(node, mapConfig);

      this.state.locations.forEach(location => {
        const marker = new google.maps.Marker({
          position: { lat: Number(location.latitude), lng: Number(location.longitude) },
          map: this.map,
          title: location.location,
        });
        marker.addListener('click', () => {
          // Open the selection menu instead of routing directly
          this.setState({ selectedLocation: location });
        });
      })
      
      this.setState({ isMapLoaded: true });
    }
  }

  render() {
    const style = { 
      width: '100vw',
      height: '100vh',
      margin: '0',
      position: 'absolute',
      top: 0,
      left: 0
    }
    
    const { selectedLocation, isMapLoaded } = this.state;
    
    return ( 
      <>
        {!isMapLoaded && (
          <div className="map-loading-overlay">
            <div className="map-loading-spinner"></div>
            <p>Loading your travels...</p>
          </div>
        )}
        
        <div ref={this.mapRef} style={style}>
          loading map...
        </div>
        
        {selectedLocation && (
          <div className="location-menu-overlay">
            <button className="location-menu-close" onClick={() => this.setState({ selectedLocation: null })}>&times;</button>
            <div className="location-menu-title">View Pictures By</div>
            
            <button className="location-menu-btn" onClick={() => this.props.history.push(`/pictures?category=${encodeURIComponent(selectedLocation.category)}`)}>
              <span className="label">Trip</span>
              <span className="value">{selectedLocation.category}</span>
            </button>
            
            <button className="location-menu-btn" onClick={() => this.props.history.push(`/pictures?country=${encodeURIComponent(selectedLocation.country)}`)}>
              <span className="label">Country</span>
              <span className="value">{selectedLocation.country}</span>
            </button>
            
            <button className="location-menu-btn" onClick={() => this.props.history.push(`/pictures?location=${encodeURIComponent(selectedLocation.location)}`)}>
              <span className="label">Location</span>
              <span className="value">{selectedLocation.location}</span>
            </button>
          </div>
        )}
      </>
    )
  }
}

export default withRouter(MapContainer);
